import { createListenerMiddleware } from '@reduxjs/toolkit';
import { RootState, AppDispatch } from '..';
import { cartActions } from '../slices/cartSlice';
import ProductApi from '@/api/ProductApi';

export const cartListenerMiddleware = createListenerMiddleware();

cartListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: cartActions.removeCartItem,
	effect: async ({ payload }, listenerApi) => {
		await ProductApi.delete(payload);
	},
});
